import { Expose } from "class-transformer";
export default class CastCategoryRes {
  @Expose() readonly castCategoryId!: number;
  @Expose() readonly name!: string;
}
